import { Box } from '@mui/material';

function NavIcon({ src, alt, sx }) {
	return <Box component="img" src={src} alt={alt} sx={sx} />;
}

export default NavIcon;
